export var schema = {
  title: "Motor Vehicle Windscreen",
  description: "Motor Vehicle Windscreen Claim Form",
  type: "object",
  properties: {
    incident: {
      type: "object",
      title: "Incident",
      required: ["insuredName", "insuredPolicyNumber", "brokeremail"],
      properties: {
        insuredName: {
          type: "string",
          title: "Name of Insured"
        },
        insuredPolicyNumber: {
          type: "string",
          title: "Policy Number"
        },
        incidentContactPerson: {
          type: "string",
          title: "Contact Person"
        },
        incidentContactNumber: {
          type: "string",
          title: "Contact Phone Number"
        },
        incidentContactEmail: {
          type: "string",
          title: "Contact Email Address",
          format: "email"
        },
        incidentVatNumber: {
          type: "string",
          title: "VAT Number"
        },
        brokeremail: {
          type: "string",
          title: "Broker Email",
          format: "email"
        }
      }
    },
    insured: {
      type: "object",
      title: "Insured",
      properties: {
        incidentDateLoss: {
          type: "string",
          title: "Date of Loss",
          format: "date-time"
        },
        incidentDateDiscovered: {
          type: "string",
          title: "Date Discovered",
          format: "date"
        },
        incidentDateReported: {
          type: "string",
          title: "Date Reported",
          format: "date"
        },
        incidentChipRepair: {
          type: "boolean",
          title: "Chip Repair"
        },
        incidentCrackedShattered: {
          type: "boolean",
          title: "Cracked or Shattered"
        },
        incidentBusinessPurpose: {
          type: "boolean",
          title: "Was vehicle used for business purposes at time of loss?"
        },
        incidentCause: {
          type: "string",
          title: "Cause of breakage"
        },
        incidentDriverName: {
          type: "string",
          title: "Driver's name at time of incident"
        }
      }
    },
    vehicleDetails: {
      type: "object",
      title: "Vehicle Details",
      properties: {
        vehicleMake: {
          type: "string",
          title: "Make"
        },
        vehicleModel: {
          type: "string",
          title: "Model"
        },
        vehicleYear: {
          type: "string",
          title: "Year"
        },
        vehicleRegistration: {
          type: "string",
          title: "Registration Number"
        },
        vehicleVinNumber: {
          type: "string",
          title: "VIN Number"
        },
        vehicleChassisNumber: {
          type: "string",
          title: "Chassis Number"
        }
      }
    },
    attachments: {
      type: "object",
      title: "Attachments",
      properties: {
        attachmentsList: {
          title: "Attachments",
          type: "array",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    declaration: {
      type: "object",
      required: ["insuredaccepttc"],
      title: "Declaration",
      description: "I/we declare that to the best of my / our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept terms and conditions",
          description: "Tick box to accept terms and conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};
export var uiSchema = {};